import React, { useState, useEffect } from 'react';
import { Container, ContentButtons } from './styles';
import { smallDateFormat } from '../../../../../utils/Utils';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const Activity = ({ graph_active_day_by_day }) => {
  const [filteredData, setFilteredData] = useState(graph_active_day_by_day);
  const [filter, setFilter] = useState('day');

  useEffect(() => {
    if (filter === 'month') {
      setFilteredData(formatDataByMonth(graph_active_day_by_day));
    } else if (filter === 'year') {
      setFilteredData(formatDataByYear(graph_active_day_by_day));
    } else {
      setFilteredData(formatDataByDay(graph_active_day_by_day));
    }
  }, [filter, graph_active_day_by_day]);

  const formatDataByMonth = (data) => {
    const groupedByMonth = data.reduce((acc, curr) => {
      const month = curr.date.slice(0, 7); // Formato YYYY-MM
      if (!acc[month]) {
        acc[month] = 0;
      }
      acc[month] += curr.id_count;
      return acc;
    }, {});
    return Object.keys(groupedByMonth).map(month => ({
      date: month,
      id_count: groupedByMonth[month]
    }));
  };

  const formatDataByYear = (data) => {
    const groupedByYear = data.reduce((acc, curr) => {
      const year = curr.date.slice(0, 4); // Formato YYYY
      if (!acc[year]) {
        acc[year] = 0;
      }
      acc[year] += curr.id_count;
      return acc;
    }, {});
    return Object.keys(groupedByYear).map(year => ({
      date: year,
      id_count: groupedByYear[year]
    }));
  };

  const formatDataByDay = (data) => {
    return data.slice(-10); // Últimos 10 dias
  };

  const getLabel = (date) => {
    if (filter === 'month') {
      const [year, month] = date.split('-');
      return new Date(year, month - 1).toLocaleString('pt-br', { month: 'long' });
    }
    if (filter === 'year') {
      return date;
    }
    return smallDateFormat(date);
  };

  const labels = filteredData
    ? filteredData.map(elem => getLabel(elem.date))
    : [];

  const data = {
    labels: labels,
    datasets: [{
      data: filteredData
        ? filteredData.map(elem => elem.id_count)
        : [],
      backgroundColor: '#4d86bb',
      borderColor: '#4d86bb',
      borderWidth: 1,
    }]
  };

  const options = {
    responsive: true, // Faz o gráfico responsivo
    maintainAspectRatio: false, // Permite o ajuste da altura
    scales: {
      x: {
        display: false
      }
    },
    plugins: {
      legend: {
        display: false
      },
    }
  };

  return (
    <Container>
      <ContentButtons>
        <label htmlFor="filter">Evolução dos Alunos Ativos</label>
        <select id="filter" value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="day">Dia</option>
          <option value="month">Mes</option>
          <option value="year">Ano</option>
        </select>
      </ContentButtons>
      <div style={{ maxHeight: '250px', height: '100%', width: '100%', maxWidth: "500px" }}>

        <Bar
          height={300}
          data={data} options={options} />
      </div>
    </Container>
  );
};

export default Activity;
